import { useState } from 'react';
import { getVehicleByQRCode } from '@/services/samsara';
import type { SamsaraVehicle } from '@/types';
import toast from 'react-hot-toast';

export function useQRVehicleScan() {
  const [scannerOpen, setScannerOpen] = useState(false);
  const [scannedVehicle, setScannedVehicle] = useState<SamsaraVehicle | null>(null);
  const [looking, setLooking] = useState(false);

  async function handleScan(qrValue: string) {
    setScannerOpen(false);
    setLooking(true);
    try {
      const vehicle = await getVehicleByQRCode(qrValue);
      if (vehicle) {
        setScannedVehicle(vehicle);
      } else {
        toast.error('Vehicle not found. Please select manually.');
      }
    } catch {
      toast.error('Failed to look up vehicle. Please try again.');
    } finally {
      setLooking(false);
    }
  }

  function closeScanner() {
    setScannerOpen(false);
  }

  function closeConfirm() {
    setScannedVehicle(null);
  }

  return {
    scannerOpen,
    scannedVehicle,
    looking,
    openScanner: () => setScannerOpen(true),
    handleScan,
    closeScanner,
    closeConfirm,
  };
}